import { HedgePlanTermReportModel } from '../../../../Generated/Commodity-Management-Api';

// Shared by the matrix table (renders bands, hover previews them) and the combined chart
// (plots the pinned/previewed band as a y-axis band). The bands themselves come from the backend.
export interface MatrixBand {
  /** The lower percentile identifies the band in the Forecast matrix palette. */
  percentile: number;
  label: string;
  lowValue: number;
  highValue: number;
}

/** The report's latest decile bands, highest prices first. */
export function buildMatrixBands(matrix: HedgePlanTermReportModel): MatrixBand[] {
  return (matrix.summary?.decileBands ?? []).map((band) => ({
    percentile: band.percentile ?? 0,
    label: band.label ?? '',
    lowValue: band.lowValue ?? 0,
    highValue: band.highValue ?? 0,
  }));
}

/** Finds which band a hovered or last-close price falls into, matching the backend: the top and bottom bands are open-ended. */
export function findMatrixBand(bands: MatrixBand[], price: number | undefined): MatrixBand | undefined {
  if (price === undefined) {
    return undefined;
  }

  return bands.find((band, index) =>
    index === 0
      ? price >= band.lowValue
      : index === bands.length - 1
        ? price < band.highValue
        : price >= band.lowValue && price < band.highValue);
}
